import React, { useState } from 'react';
import styles from './style.module.css';
import {
  classScheduleIcon,
  classScheduleIconHover,
  notificationIcon,
  notificationIconHover,
  nutritionIcon,
  nutritionIconHover,
  statementIcon,
  statementIconHover,
  trainingIcon,
  trainingIconHover,
  billingIcon,
  billingIconHover,
  contactUsIcon,
  contactUsIconHover,
  wrench,
  bellDot,
} from 'assets/newIcons';
import Text from 'components/shared/Text';
import MobileContext from 'context/MobileContext';
import { useContext } from 'react';
import { useHistory } from 'react-router';
import { useSelector } from 'react-redux';
import PolkMemberPopUp from 'components/shared/PolkMemberPopUp';
import StatusPopup from 'components/shared/StatusPopup';

const Container1 = ({ defaultImage, hoverImage, heading, content, linkName, link, onCustomClick }) => {
  const [isHovered, setHovered] = useState(false);
  const history = useHistory();
  const isMobile = useContext(MobileContext);
  const mobClassName = isMobile ? styles.mob : null;

  const handleHover = () => {
    setHovered(true);
  };

  const handleMouseLeave = () => {
    setHovered(false);
  };

  return (
    <div
      onMouseOver={handleHover}
      onMouseLeave={handleMouseLeave}
      className={`${styles.subContainer1} ${mobClassName}`}
      onClick={() => onCustomClick ? onCustomClick() : history.push(link)}
    >
      <img alt="" src={isHovered ? hoverImage : defaultImage} className={styles.logo} />
      <div className={styles.headingContainer}>
        <Text className={styles.heading}>{heading}</Text>
      </div>

      <div className={styles.textContainer}>
        <Text className={styles.content}>{content}</Text>
      </div>

      <div className={styles.linkWrapper}>
        <a href={() => false} className={styles.link}>
          {linkName}
        </a>
      </div>
    </div>
  );
};

const Container2 = ({ defaultImage, hoverImage, heading, content, linkName, link }) => {
  const [isHovered, setHovered] = useState(false);
  const history = useHistory();
  const isMobile = useContext(MobileContext);
  const mobClassName = isMobile ? styles.mob : null;

  const handleHover = () => {
    setHovered(true);
  };

  const handleMouseLeave = () => {
    setHovered(false);
  };

  return (
    <div
      onMouseOver={handleHover}
      onMouseLeave={handleMouseLeave}
      className={`${styles.subContainer2} ${mobClassName}`}
      onClick={() => history.push(link)}
    >
      <img alt="" src={isHovered ? hoverImage : defaultImage} className={styles.logo} />
      <div className={styles.headingContainer}>
        <Text className={styles.heading}>{heading}</Text>
      </div>
      <div className={styles.textContainer}>
        <Text className={styles.content}>{content}</Text>
      </div>
      <div className={styles.linkWrapper}>
        <a href={() => false} className={styles.link}>
          {linkName}
        </a>
      </div>
    </div>
  );
};

const Menu = ({ profileDetails }) => {
  const isMobile = useContext(MobileContext);
  const mobClassName = isMobile ? styles.mob : null;
  const marginTop = isMobile ? null : '70px';
  const [openPolkPopUp, setOpenPolkPopUp] = useState(false);
  const [isPaymentsPausedPopupOpen, setPaymentsPausedPopupOpen] = useState(false);
  const history = useHistory();
  const termsAgreementDetails = useSelector(
    state => state?.termsAndConditions?.termsAgreementDetails
  );
  const enablePayments = termsAgreementDetails?.enablePayments;
  const isProfileLoaded = Object.keys(profileDetails || {}).length > 0;
  const isConfigLoaded = Object.keys(termsAgreementDetails || {}).length > 0;

  const handleNutritionClick = () => {
    if (localStorage.getItem('isPolkMember') === 'true') {
      setOpenPolkPopUp(true);
    } else {
      history.push('/nutrition');
    }
  };

  const handleBillingClick = () => {
    if (!isProfileLoaded || !isConfigLoaded) {
      return;
    }
    if (enablePayments === false) {
      setPaymentsPausedPopupOpen(true);
    } else {
      history.push('/billing-info');
    }
  };

  return (
    <>
      <PolkMemberPopUp open={openPolkPopUp} setOpenPolkPopUp={setOpenPolkPopUp} />
      <StatusPopup
        open={isPaymentsPausedPopupOpen}
        onClose={() => setPaymentsPausedPopupOpen(false)}
        icon={wrench}
        iconAlt="Payments paused"
        title="PAYMENTS ARE PAUSED"
        description={`We're upgrading our payment system to make transactions safer and faster.\nYou won't be able to make payments until this is done. Nothing on your end needs fixing.`}
        notifyIcon={bellDot}
        notifyText="We'll notify you the moment it's back."
      />
      <div
        style={{ marginTop: marginTop }}
        className={`${styles.container} ${mobClassName}`}
      >
        <Container1
          defaultImage={trainingIcon}
          hoverImage={trainingIconHover}
          heading={'Training'}
          content={' View your upcoming sessions with your Personal Trainer.'}
          linkName={'View Sessions'}
          link={'/training'}
        />

        <Container2
          defaultImage={statementIcon}
          hoverImage={statementIconHover}
          heading={'Statements & Check-Ins'}
          content={' View your account statements & check-ins.'}
          linkName={' Access Documents'}
          link={'/statement-checkins'}
        />
      </div>

      <div
        style={{ marginTop: marginTop }}
        className={`${styles.container} ${mobClassName}`}
      >
        <Container1
          defaultImage={nutritionIcon}
          hoverImage={nutritionIconHover}
          heading={'Nutrition'}
          content={'Plan, cook, and track your meals with convenience in mind.'}
          linkName={'Track Meals'}
          link={'/nutrition'}
          onCustomClick={handleNutritionClick}
        />

        <Container2
          defaultImage={classScheduleIcon}
          hoverImage={classScheduleIconHover}
          heading={'Class Schedule'}
          content={
            'Explore our class schedule at select locations, from Yoga to BodyPump.'
          }
          linkName={'View Classes'}
          link={'/classes'}
        />
      </div>

      <div
        style={{ marginTop: marginTop }}
        className={`${styles.container} ${mobClassName}`}
      >
        <Container1
          defaultImage={billingIcon}
          hoverImage={billingIconHover}
          heading={'Billing Information'}
          content={'Pay your bill or update your credit card information.'}
          linkName={'Manage Billing Info'}
          link={'/billing-info'}
          onCustomClick={handleBillingClick}
        />

        <Container2
          defaultImage={contactUsIcon}
          hoverImage={contactUsIconHover}
          heading={'Contact Us'}
          content={'Fill out a form to connect with our team for support.'}
          linkName={'Submit to Form'}
          link={'/contact-us'}
        />
      </div>

      {/* <div
        style={{ marginTop: marginTop }}
        className={`${styles.container} ${mobClassName}`}
      >
        <Container1
          defaultImage={notificationIcon}
          hoverImage={notificationIconHover}
          heading={'Notifications'}
          content={'Manage your communication preferences.'}
          linkName={'Set Notification'}
          link={{ pathname: '/notification', state: profileDetails }}
          user={profileDetails}
        />
      </div> */}
    </>
  );
};

export default Menu;
